import { cn } from "@/lib/utils";
import type { ComponentProps, ReactNode } from "react";
import ProductCardBadge from "./ProductCardBadge";
import ProductCardBrand from "./ProductCardBrand";
import ProductCardContent from "./ProductCardContent";
import ProductCardImage from "./ProductCardImage";
import ProductCardLink from "./ProductCardLink";
import ProductCardMeta from "./ProductCardMeta";
import ProductCardPrice from "./ProductCardPrice";
import ProductCardStockStatus from "./ProductCardStockStatus";
import ProductCardTitle from "./ProductCardTitle";
// import ProductCardTrackedLink from "./ProductCardTrackedLink";
import ProductCardVariants from "./ProductCardVariants";

export default function ProductCard({
  children,
  className,
  ...props
}: {
  className?: string;
  children?: ReactNode;
} & ComponentProps<"article">) {
  return (
    <article
      className={cn(
        "group/product-card @container/product-card relative shrink-0 overflow-hidden",
        className,
      )}
      {...props}
    >
      {children}
    </article>
  );
}

ProductCard.Link = ProductCardLink;
// ProductCard.TrackedLink = ProductCardTrackedLink;
ProductCard.Image = ProductCardImage;
ProductCard.Badge = ProductCardBadge;
ProductCard.Meta = ProductCardMeta;
ProductCard.StockStatus = ProductCardStockStatus;
ProductCard.Variants = ProductCardVariants;
ProductCard.Content = ProductCardContent;
ProductCard.Brand = ProductCardBrand;
ProductCard.Title = ProductCardTitle;
ProductCard.Price = ProductCardPrice;
